"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import { cicToType } from "@/helpers/Helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ProfileWinnerBadge } from "@/components/waves/drops/ProfileWinnerBadge";
import { useArtistPreviewModal } from "@/hooks/useArtistPreviewModal";
interface MemeDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
export default function MemeDropArtistInfo(t0) {
  const $ = _c(48);
  const {
    drop
  } = t0;
  const {
    isModalOpen,
    modalInitialTab,
    handleBadgeClick,
    handleModalClose
  } = useArtistPreviewModal();
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const winnerCount = drop.author.winner_main_stage_drop_ids?.length || 0;
  const isWinner = winnerCount > 0;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.cic || $[3] !== drop.author.level) {
    t2 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} cicType={cicToType(drop.author.cic)} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author.cic;
    $[3] = drop.author.level;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `/${drop.author?.handle}`;
  let t4;
  if ($[5] !== drop.author.handle || $[6] !== drop.author.id) {
    t4 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span></UserProfileTooltipWrapper> : <span className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold">{drop.author?.handle}</span>;
    $[5] = drop.author.handle;
    $[6] = drop.author.id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Link href={t3} onClick={_temp} className="tw-no-underline">{t4}</Link>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== drop.id || $[12] !== handleBadgeClick || $[13] !== isWinner || $[14] !== winnerCount) {
    t6 = isWinner && <ProfileWinnerBadge winCount={winnerCount} onBadgeClick={() => handleBadgeClick("winners")} tooltipId={`meme-winner-badge-${drop.id}`} />;
    $[11] = drop.id;
    $[12] = handleBadgeClick;
    $[13] = isWinner;
    $[14] = winnerCount;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== drop.id || $[17] !== handleBadgeClick || $[18] !== hasSubmissions || $[19] !== submissionCount) {
    t7 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={() => handleBadgeClick("active")} tooltipId={`meme-badge-${drop.id}`} />;
    $[16] = drop.id;
    $[17] = handleBadgeClick;
    $[18] = hasSubmissions;
    $[19] = submissionCount;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== drop.created_at) {
    t9 = <WaveDropTime timestamp={drop.created_at} />;
    $[22] = drop.created_at;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = drop.winning_context?.decision_time ?? null;
  let t11;
  if ($[24] !== drop.rank || $[25] !== t10) {
    t11 = <div className="tw-ml-2"><WinnerDropBadge rank={drop.rank} decisionTime={t10} /></div>;
    $[24] = drop.rank;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t2 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t9) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-2">{t2}{t5}{t6}{t7}{t8}{t9}{t11}</div>;
    $[27] = t11;
    $[28] = t2;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== drop.wave) {
    t13 = drop.wave && <Link onClick={_temp2} href={`/waves?wave=${drop.wave.id}`} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    $[34] = drop.wave;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t12 || $[37] !== t13) {
    t14 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t12}{t13}</div>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== drop.author || $[40] !== handleModalClose || $[41] !== isModalOpen || $[42] !== modalInitialTab) {
    t15 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[39] = drop.author;
    $[40] = handleModalClose;
    $[41] = isModalOpen;
    $[42] = modalInitialTab;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t1 || $[45] !== t14 || $[46] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-3">{t1}{t14}{t15}</div>;
    $[44] = t1;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  return t16;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}